export default {
  isSubmitKeyPressed(event: React.KeyboardEvent<HTMLElement>) {
    return event.key === 'Enter' || event.key === ' ';
  },
};
